module.exports = __webpack_public_path__ + "img/customer.bf41fbee.svg";